module.exports = __webpack_public_path__ + "static/img/pdf.7e6ae0e3.svg";